export default __webpack_public_path__ + "static/const-eight-9da1ddb30ef495b8423217739f24ad92.png";